/** Client-side mirror of the source formulas – for live feedback while typing. The server is authoritative on save. */
const CLASS_FORMULA = (s, k) => {
  const p = (s || 0) * (k || 0);
  if (p >= 10) return "KRITISK";
  if (s === 2 && k === 2) return "AKSEPTABEL";
  if (p >= 5) return "BETYDELIG";
  if (p > 0) return "AKSEPTABEL";
  return "IKKE DEF";
};

function scoreOf(side, matrix, bands, extended) {
  const s = side?.s ?? null, k = side?.k ?? null;
  const value = s && k ? s * k : null;
  const bandKey = s && k ? matrix[s]?.[k - 1] : null;
  return { s, k, value, band: bandKey ? bands[bandKey] : null, ...(extended ? { class: CLASS_FORMULA(s, k) } : {}) };
}

export function evalLine(line, meta, extended) {
  const before = scoreOf(line.before, meta.matrix, meta.bands, extended);
  const after = scoreOf(line.after, meta.matrix, meta.bands, extended);
  let state;
  if (line.relevance === "ikke_relevant") state = (line.relevance_reason || "").trim() ? "ikke_relevant" : "mangler_begrunnelse";
  else if (line.relevance === "relevant") state = [before.s, before.k, after.s, after.k].every((x) => x != null) ? "vurdert" : "mangler_score";
  else state = "ikke_tatt_stilling";
  return { ...line, before, after, state };
}

export function sectionCounts(lines) {
  const n = (st) => lines.filter((l) => l.state === st).length;
  return { total: lines.length, vurdert: n("vurdert"), ikke_relevant: n("ikke_relevant"), open: lines.length - n("vurdert") - n("ikke_relevant") };
}

export const CONTENT_KEYS = ["checklist", "fields", "register", "extended", "extended_header"];

/** Strip computed fields so the draft compares and posts cleanly. */
export function toDraft(assessment) {
  const strip = (l) => ({ id: l.id, phase: l.phase, label: l.label || "", template: Boolean(l.template), source_row: l.source_row ?? null, relevance: l.relevance ?? null, relevance_reason: l.relevance_reason || "", description: l.description || "",
    before: { s: l.before?.s ?? null, k: l.before?.k ?? null }, measure: l.measure || "", after: { s: l.after?.s ?? null, k: l.after?.k ?? null }, responsible: l.responsible || "", done: l.done ?? null, comment: l.comment || "",
    ...(l.hazard !== undefined || l.reservation !== undefined ? { hazard: l.hazard || "", reservation: l.reservation || "" } : {}) });
  return {
    checklist: Object.fromEntries(Object.entries(assessment.checklist || {}).map(([k, v]) => [k, { answer: v?.answer ?? null, comment: v?.comment || "" }])),
    fields: { ...(assessment.fields || {}) },
    register: (assessment.register || []).map(strip),
    extended: (assessment.extended || []).map((l) => strip({ hazard: "", reservation: "", ...l })),
    extended_header: { prosjektleder: "", tilstede: "", dato: "", ...(assessment.extended_header || {}) },
  };
}

export function newLine(phase, extended) {
  return { id: `new-${Math.random().toString(36).slice(2, 10)}`, phase, label: "", template: false, source_row: null, relevance: "relevant", relevance_reason: "", description: "", before: { s: null, k: null }, measure: "", after: { s: null, k: null }, responsible: "", done: null, comment: "", ...(extended ? { hazard: "", reservation: "" } : {}) };
}
